import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {LensModel} from '../../../../../models/api/lensModel';

interface DeleteLensDialogProps {
  lens: LensModel;
  onClose: () => void;
  onDelete: () => Promise<void>;
  isTeamLens?: boolean;
}

export const DeleteLensDialog: FC<DeleteLensDialogProps> = (props) => {
  const {lens, onClose, onDelete} = props;
  const dialogText = props.isTeamLens ? (
    <Trans id="delete-lens-confirmation-dialog-shared-lens-text">
      Permanently deleting this view will remove it from all teammate sidebars. This <b>cannot</b> be undone.
    </Trans>
  ) : (
    <Trans id="delete-lens-confirmation-dialog-private-lens-text">
      This view will be permanently deleted. This <b>cannot</b> be undone.
    </Trans>
  );

  return (
    <OkCancelDialog
      title={`Delete "${lens.name}" view`}
      okButtonLabel={<Trans id="delete-lens-confirmation-dialog-delete-button">Delete permanently</Trans>}
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onRequestClose={onClose}
      onOkClick={onDelete}
    >
      {dialogText}
    </OkCancelDialog>
  );
};
